export enum ActivityGroupSettingsAiDifficulty {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
  ASCENDING = 'ascending',
}
